import { useGlobalData } from "../data/GeneralData";
import { Link } from "react-router-dom";
import { useState } from "react";

import { SpeakerCardSlider } from "../components/Speakers";
import VideoModal from "../components/VideoModal";
import SpeakerData25 from "../data/SpeakerData25";

export default function PageComingSoon() {
  const { date, year, hotel, location } = useGlobalData();

  const [isOpen, setIsOpen] = useState(false);
  const [videoId, setVideoId] = useState(null);

  const openOverlay = (id) => {
    setVideoId(id);
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeOverlay = () => {
    setIsOpen(false);
    setVideoId(null);
    document.body.style.overflow = "auto";
  };

  return (
    <>
      {/* ── 1. Hero Banner ───────────────────────────────────────────── */}
      <div className="bg-vertical-red-purple hero-banner">
        <div
          className="cover-image"
          style={{
            "--bg-desktop": `url(/img/bg-banner-short-2027.webp)`,
            "--bg-mobile": `url(/img/bg-banner-mobile-2027.webp)`,
          }}
        >
          <section className="">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                {/* Left: copy */}
                <div className="col-12 col-lg-7 py-5 text-center text-lg-start">
                  <h4 className="color-white mb-2">
                    <span>
                      {date}, {year}
                    </span>
                    <span className="spacer px-1 px-lg-2 px-xl-3">•</span>
                    <span>{hotel}</span>
                    <span className="spacer px-1 px-lg-2 px-xl-3">•</span>
                    <span>{location}</span>
                  </h4>
                  <h1 className="color-white">
                    Experience the country's only{" "}
                    <mark className="purple-highlight">
                      compensation conference
                    </mark>{" "}
                    for all HR levels working in banks and{" "}
                    <span className="nobr">credit unions</span>
                  </h1>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* ── 2. Recap / Video Section ─────────────────────────────────── */}
      <section className="bg-white bg-rounded mt-5 mb-4">
        <div className="container mb-5">
          <div className="row align-items-center">
            {/* Video thumb */}
            <div className="col-12 col-lg-6 col-xl-7 mb-5 mb-md-0">
              <div
                className="video-thumb"
                onClick={() => openOverlay("_OWaUt64AIM")}
              >
                <img
                  className="img-fluid bg-rounded"
                  src="/img/graphic-videothumb-2025.webp"
                  alt="FinComp Highlight Reel"
                />
                {/* <div className="play-btn">
                  <i className="fas fa-play" aria-hidden="true"></i>
                </div> */}
              </div>
            </div>

            {/* Text */}
            <div className="col-12 col-lg-6 col-xl-5">
              <h2 className="color-purple mb-3 mt-md-4">
                Relive the best moments
                <br /> from FinComp '25
              </h2>
              <p>
                Last year's symposium was a powerhouse of inspiration, equipping
                HR professionals with cutting-edge tools to lead with
                confidence, navigate economic challenges, and revolutionize
                compensation strategies in a dynamic industry.
              </p>
              <p>
                The energy was palpable, the insights were transformative, and
                the connections forged will shape the future of HR leadership.
              </p>
              <p>
                <Link
                  target="_blank"
                  to="https://balancedcomp.com/articles/fincomp-2025-recap-a-thrilling-leap-forward-for-hr-leadership-in-compensation-strategy/"
                  className="color-red text-decoration-none"
                >
                  Read the recap <i className="fa fa-arrow-right"></i>
                </Link>
              </p>
              {/* <p>
                <Link
                  to="/2025/Agenda"
                  className="color-red text-decoration-none"
                >
                  Revisit the agenda <i className="fa fa-arrow-right"></i>
                </Link>
              </p> */}
            </div>
          </div>
        </div>

        <VideoModal isOpen={isOpen} videoId={videoId} onClose={closeOverlay} />

        {/* ── 3. Speaker Card Slider ───────────────────────────────────── */}

        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <SpeakerCardSlider
                data={SpeakerData25}
                order="Christie Summervill,Urs Koenig,Amy Downs"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ── 4. Photo Row ─────────────────────────────────────────────── */}
      <img className="img-fluid" src="/img/img-photorow-2025.webp" alt="" />

      {/* ── 5. Sponsorship Callout ───────────────────────────────────── */}

      <div className="sponsor-callout">
        <div
          className="sponsor-callout-year"
          style={{
            backgroundImage: `
          url(./img/bg-2027.svg)
        `,
          }}
        ></div>
        <section>
          <div className="container">
            <div className="row align-items-center justify-content-between text-center text-lg-start">
              {/* Logo */}
              <div className="col-12 col-lg-5 col-xl-4 mb-5 mb-xl-0">
                <img
                  className="img-fluid"
                  src="/img/logo-fincomp-stacked.svg"
                  alt="FinComp presented by BalancedComp"
                />
              </div>

              <div className="col-12 col-lg-7">
                <span
                  className="display-1 color-white mb-4"
                  style={{ maxWidth: "18em", display: "inline-block" }}
                >
                  Explore exclusive sponsorship{" "}
                  <mark className="purple-highlight">
                    opportunities to showcase
                  </mark>{" "}
                  your brand to industry leaders.
                </span>
                <Link to="/Sponsors" className="btn-white-o">
                  Become a Sponsor
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
